import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ClearIcon, SuccessIcon, WarnIcon } from "../../components/icon";
import { createToastApi, createToastTimer } from "./model.js";
import "./index.scss";
export { createToastApi, createToastTimer, normalizeToast } from "./model.js";
const IconMap = {
    error: _jsx(ClearIcon, { color: "#ff4d4f" }),
    warning: _jsx(WarnIcon, {}),
    success: _jsx(SuccessIcon, {}),
};
function ToastView({ toast, exiting = false }) {
    if (!toast)
        return null;
    return (_jsxs("div", { className: `smm-auth-toast${exiting ? " smm-auth-toast-exiting" : ""}`, role: "alert", children: [!!toast.type && _jsx("span", { className: "smm-auth-toast-icon", children: IconMap[toast.type] }), _jsx("div", { className: "smm-auth-toast-content", children: toast.content })] }));
}
export const useToast = () => {
    var _a, _b;
    const [activeToast, setActiveToast] = useState(null);
    const animationKeyRef = useRef(0);
    const timerRef = useRef(null);
    if (timerRef.current === null) {
        timerRef.current = createToastTimer((callback, delay) => window.setTimeout(callback, delay), (timer) => window.clearTimeout(timer));
    }
    const destroy = useCallback(() => {
        var _a;
        (_a = timerRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        setActiveToast(null);
    }, []);
    const show = useCallback((nextToast) => {
        var _a;
        animationKeyRef.current += 1;
        const animationKey = animationKeyRef.current;
        setActiveToast({ animationKey, exiting: false, message: nextToast });
        (_a = timerRef.current) === null || _a === void 0 ? void 0 : _a.restart(() => {
            setActiveToast((currentToast) => (currentToast === null || currentToast === void 0 ? void 0 : currentToast.animationKey) === animationKey ? Object.assign(Object.assign({}, currentToast), { exiting: true }) : currentToast);
        }, () => {
            setActiveToast((currentToast) => ((currentToast === null || currentToast === void 0 ? void 0 : currentToast.animationKey) === animationKey ? null : currentToast));
        });
    }, []);
    const messageApi = useMemo(() => createToastApi(show, destroy), [destroy, show]);
    useEffect(() => () => { var _a; return (_a = timerRef.current) === null || _a === void 0 ? void 0 : _a.clear(); }, []);
    return [
        messageApi,
        _jsx(ToastView, { toast: (_a = activeToast === null || activeToast === void 0 ? void 0 : activeToast.message) !== null && _a !== void 0 ? _a : null, exiting: activeToast === null || activeToast === void 0 ? void 0 : activeToast.exiting }, (_b = activeToast === null || activeToast === void 0 ? void 0 : activeToast.animationKey) !== null && _b !== void 0 ? _b : "smm-auth-toast"),
    ];
};
const Toast = Object.assign(ToastView, { useToast });
export default Toast;
//# sourceMappingURL=index.js.map